import React from 'react';

import { Content } from './Content.js';
import NrgComponent from './../NrgComponent.jsx';
import getIcon from '../../icons/svgController.js';
import getImgIcon from '../../icons/iconController.js';

export default class ClientListPanel extends NrgComponent {
  constructor(props) {
    super(props);
  }
  render() {
    var icons = Content[this.props.page].clients;

    return (
      <div className="ClientListPanel row">
        <div className="col-xs-16">
          <h4>{Content[this.props.page].title}</h4>
        </div>
        {icons.map((icon, index) => {

          let Icon = getIcon(icon.iconName)

          return <div className="col-xs-8 col-sm-4" key={index} data-scroll-item-once>
            <div className="client-logo">
              {icon.iconType == 'IconImage' ?
                <div className="icon-image-container"><img className="icon-image" src={getImgIcon(icon.iconName)} alt="content" /></div>
                :
                <React.Fragment>{icon.iconName && <Icon viewBox="0 0 145 80"></Icon>}</React.Fragment>
              }
            </div>
          </div>
        })}
      </div>
    );
  }

};
